var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('avatar',{attrs:{"color":_vm.logoUrl
      ? 'transparent'
      : _vm.color || _vm.getColor(_vm.$vuetify.theme.themes.light.secondarytext, 0.1),"avatarUrl":_vm.logoUrl,"name":_vm.name,"cssClass":_vm.cssClass,"size":_vm.size,"borderColor":_vm.borderColor,"textColor":_vm.textColor,"icon":_vm.logoUrl ? '' : 'business',"iconColor":_vm.textColor,"iconSize":_vm.iconSize}})}
var staticRenderFns = []

export { render, staticRenderFns }